import { createReduxModule } from "hooks-for-redux";

const initialState = {
  willCreateAccountType: null,
  guestUsername: null,
  guestElo: null,
  token: null,
  progressKey: null,
};

const [useRegister, { guestRegister, willCreateAccountType, setProgressKey }] =
  createReduxModule("register", initialState, {
    guestRegister: (state, { username, elo }) => ({
      ...state,
      guestUsername: username,
      guestElo: elo,
    }),
    willCreateAccountType: (state, { accountType, token }) => ({
      ...state,
      willCreateAccountType: accountType,
      token,
    }),
    setProgressKey: (state, progressKey) => ({
      ...state,
      progressKey,
    }),
  });

export { useRegister, guestRegister, willCreateAccountType, setProgressKey };
